import View from './stats-view';

export default View;
